import React, { useState } from 'react';

const ZygoSecPrivacy = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div style={styles.container}>
      <style>{`a
        @media (max-width: 768px) {
          .nav-links { display: none !important; }
          .mobile-menu-btn { display: flex !important; }
          .page-title { font-size: 36px !important; }
          .team-grid { grid-template-columns: repeat(2, 1fr) !important; }
          .values-grid { grid-template-columns: 1fr !important; }
        }
        @media (max-width: 480px) {
          .team-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>

      {/* Dot pattern background */}
      <div style={styles.dotPattern} />

      {/* Navigation */}
      <nav style={styles.nav}>
        <div style={styles.navInner}>
          <div style={styles.logo}>
           <a href="https://zygosec.com">
            <img style={{width: '100px', padding: 0, margin: 0}} class="w-[100px] p-0 m-0" src={require('../images/zygosec-dark.png')} id="logo"/>
           </a>
          </div>
          <div className="nav-links" style={styles.navLinks}>
           
            {/* <a href="/blog" style={{...styles.navLink, color: 'rgb(17, 42, 46)'}}>Blog</a> */}
            <a href="#" style={styles.navLink}>About</a>
          </div>
          
        </div>
        {menuOpen && (
          <div style={styles.mobileMenu}>
            <a href="/blog" style={styles.mobileNavLink}>Blog</a>
            <a href="#" style={styles.mobileNavLink}>About</a>
          </div>
        )}
      </nav>

      {/* Hero */}
      <header style={styles.hero}>
        <h1 className="page-title" style={styles.pageTitle}>
          Privacy
        </h1>
        <p style={styles.pageSubtitle}>
          Privacy Policy Last updated: 4th May 2026
          </p>

          <p style={styles.pageSubtitle}>
1. Introduction Welcome to ZygoSec ("we", "our", or "us"). Your privacy is important to us. This Privacy Policy explains how we collect, use, and protect your personal data when you visit our website zygosec.com and sign up for early access to our future products.
</p>

<p style={styles.pageSubtitle}>
2. Data We Collect We only collect the following personal data: Email address - when you voluntarily subscribe to our mailing list or request early access updates. We do not collect any other personal information or use cookies beyond what is necessary to operate this landing page.
</p>

<p style={styles.pageSubtitle}>
3. How We Use Your Data We use your email address to: Send you updates about our upcoming products. Inform you when early access becomes available. Share occasional news or relevant information related to our services. We will not sell, rent, or share your email address with third parties for marketing purposes.
</p>

<p style={styles.pageSubtitle}>
4. Legal Basis for Processing (GDPR) Under the EU General Data Protection Regulation (GDPR), we process your personal data based on your consent. You provide consent when you enter your email and submit it through our website form. You may withdraw your consent at any time by clicking the "unsubscribe" link in any email we send, or by contacting us directly.
</p>

<p style={styles.pageSubtitle}>
5. Data Storage and Security We use Mailchimp (operated by The Rocket Science Group LLC) to manage our email list and send communications. When you subscribe, your email address is stored and processed by Mailchimp in accordance with their Privacy Policy . Mailchimp may transfer data to servers located in the United States. Mailchimp participates in the EU-U.S. Data Privacy Framework, ensuring an adequate level of data protection under GDPR. We take appropriate technical and organizational measures to protect your data from unauthorized access, loss, or misuse.
</p>

<p style={styles.pageSubtitle}>
6. Data Retention We will keep your email address only for as long as necessary to send you updates about our project, or until you unsubscribe or request deletion.
</p>

<p style={styles.pageSubtitle}>
7. Your Rights (EU/EEA Users) Under GDPR, you have the right to: Access the personal data we hold about you. Request correction or deletion of your data. Withdraw consent at any time. Lodge a complaint with your local data protection authority. To exercise your rights, contact us at: billy@zygosec.com
</p>

<p style={styles.pageSubtitle}>
8. Third-Party Services We may use trusted third-party providers (e.g., email marketing platforms) to manage our mailing list. These providers process your data in compliance with GDPR and have appropriate security measures in place.
</p>

<p style={styles.pageSubtitle}>
9. Contact Us If you have any questions about this Privacy Policy or how we handle your data, please contact us at: billy@zygosec.com
</p>
        {/* </p> */}

        <br></br>
       
      </header>

     
      {/* Footer */}
      <footer style={styles.footer}>
        <div className="footer-inner" style={styles.footerInner}>
          <div style={styles.footerBrand}>
            <div style={styles.logo}>
            <a>
              <img style={{width: '100px', padding: 0, margin: 0}} class="w-[100px] p-0 m-0" src={require('../images/zygosec-dark.png')} id="logo"/>
            </a>
            </div>
            <p style={styles.footerTagline}>
              Acquire skills in vulnerability research, reverse engineering & exploit development.
            </p>
          </div>
          <div className="footer-links" style={styles.footerLinks}>
            <div style={styles.footerCol}>
              <h4 style={styles.footerHeading}>Resources</h4>
              {/* <a href="https://zygosec.com/blog" style={styles.footerLink}>Blog</a> */}
              <a href="https://www.youtube.com/@BillyEllis" style={styles.footerLink}>YouTube</a>
            </div>
            <div style={styles.footerCol}>
              <h4 style={styles.footerHeading}>Company</h4>
              <a href="#" style={styles.footerLink}>About</a>
            </div>
          </div>
        </div>
        <div style={styles.footerBottom}>
          <span>© 2026 ZygoSec</span>
          <div style={styles.legalLinks}>
            <a href="#" style={styles.legalLink}>Privacy</a>
            <a href="#" style={styles.legalLink}>Terms</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: '#ffffff',
    color: '#111827',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    position: 'relative'
  },
  dotPattern: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundImage: 'radial-gradient(#d1d5db 1px, transparent 1px)',
    backgroundSize: '24px 24px',
    opacity: 0.5,
    pointerEvents: 'none',
    zIndex: 0
  },
  nav: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    backgroundColor: 'rgba(255,255,255,0.9)',
    backdropFilter: 'blur(12px)',
    borderBottom: '1px solid #f3f4f6',
    zIndex: 100
  },
  navInner: {
    maxWidth: '1120px',
    margin: '0 auto',
    padding: '16px 24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  logo: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    width: 100,
  },
  logoMark: {
    fontSize: '22px',
    color: '#0d9488'
  },
  logoText: {
    fontSize: '18px',
    fontWeight: 600,
    color: '#111827',
    letterSpacing: '-0.5px'
  },
  navLinks: {
    display: 'flex',
    gap: '32px'
  },
  navLink: {
    color: '#6b7280',
    textDecoration: 'none',
    fontSize: '14px',
    fontWeight: 500
  },
  navActions: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px'
  },
  signIn: {
    color: '#6b7280',
    textDecoration: 'none',
    fontSize: '14px',
    fontWeight: 500
  },
  startBtn: {
    backgroundColor: '#0d9488',
    color: '#ffffff',
    border: 'none',
    padding: '10px 20px',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: 500,
    cursor: 'pointer'
  },
  mobileMenuBtn: {
    display: 'none',
    alignItems: 'center',
    justifyContent: 'center',
    width: '40px',
    height: '40px',
    backgroundColor: 'transparent',
    border: '1px solid #e5e7eb',
    borderRadius: '8px',
    fontSize: '18px',
    cursor: 'pointer',
    color: '#374151'
  },
  mobileMenu: {
    display: 'flex',
    flexDirection: 'column',
    padding: '16px 24px',
    borderTop: '1px solid #f3f4f6',
    backgroundColor: '#ffffff'
  },
  mobileNavLink: {
    padding: '12px 0',
    color: '#374151',
    textDecoration: 'none',
    fontSize: '16px',
    fontWeight: 500,
    borderBottom: '1px solid #f3f4f6'
  },
  hero: {
    position: 'relative',
    zIndex: 1,
    maxWidth: '700px',
    margin: '0 auto',
    padding: '140px 24px 80px',
    textAlign: 'center'
  },
  pageTitle: {
    fontSize: '48px',
    fontWeight: 700,
    color: '#111827',
    lineHeight: 1.1,
    marginBottom: '24px',
    letterSpacing: '-1px'
  },
  pageSubtitle: {
    fontSize: '18px',
    color: '#6b7280',
    lineHeight: 1.6,
    textAlign: 'left',
  },
  mission: {
    position: 'relative',
    zIndex: 1,
    backgroundColor: 'rgba(240, 253, 250, 0.5)',
    padding: '80px 24px'
  },
  missionInner: {
    maxWidth: '600px',
    margin: '0 auto'
  },
  missionContent: {},
  sectionLabel: {
    display: 'block',
    fontSize: '13px',
    fontWeight: 600,
    color: '#0d9488',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    marginBottom: '16px'
  },
  missionTitle: {
    fontSize: '32px',
    fontWeight: 700,
    color: '#111827',
    lineHeight: 1.2,
    marginBottom: '24px',
    letterSpacing: '-0.5px'
  },
  missionText: {
    fontSize: '17px',
    color: '#6b7280',
    lineHeight: 1.7,
    marginBottom: '16px'
  },
  values: {
    position: 'relative',
    zIndex: 1,
    padding: '80px 24px'
  },
  valuesInner: {
    maxWidth: '900px',
    margin: '0 auto'
  },
  sectionTitle: {
    fontSize: '32px',
    fontWeight: 700,
    color: '#111827',
    marginBottom: '48px',
    letterSpacing: '-0.5px'
  },
  valuesGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '32px'
  },
  valueCard: {
    textAlign: 'center'
  },
  valueIcon: {
    fontSize: '36px',
    display: 'block',
    marginBottom: '16px'
  },
  valueTitle: {
    fontSize: '18px',
    fontWeight: 600,
    color: '#111827',
    marginBottom: '12px'
  },
  valueText: {
    fontSize: '15px',
    color: '#6b7280',
    lineHeight: 1.6
  },
  team: {
    position: 'relative',
    zIndex: 1,
    backgroundColor: 'rgba(240, 253, 250, 0.5)',
    padding: '80px 24px'
  },
  teamInner: {
    maxWidth: '800px',
    margin: '0 auto',
    textAlign: 'center'
  },
  teamSubtitle: {
    fontSize: '17px',
    color: '#6b7280',
    marginTop: '-32px',
    marginBottom: '48px'
  },
  teamGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: '32px'
  },
  teamCard: {
    textAlign: 'center'
  },
  teamAvatar: {
    width: '80px',
    height: '80px',
    borderRadius: '50%',
    backgroundColor: '#0d9488',
    color: '#ffffff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '20px',
    fontWeight: 600,
    margin: '0 auto 16px'
  },
  teamName: {
    fontSize: '16px',
    fontWeight: 600,
    color: '#111827',
    marginBottom: '4px'
  },
  teamRole: {
    fontSize: '14px',
    color: '#6b7280'
  },
  cta: {
    position: 'relative',
    zIndex: 1,
    maxWidth: '500px',
    margin: '0 auto',
    padding: '80px 24px',
    textAlign: 'center'
  },
  ctaTitle: {
    fontSize: '32px',
    fontWeight: 700,
    color: '#111827',
    marginBottom: '12px'
  },
  ctaText: {
    fontSize: '17px',
    color: '#6b7280',
    marginBottom: '32px'
  },
  ctaButtons: {
    display: 'flex',
    gap: '12px',
    justifyContent: 'center'
  },
  ctaPrimary: {
    backgroundColor: '#0d9488',
    color: '#ffffff',
    border: 'none',
    padding: '14px 28px',
    borderRadius: '8px',
    fontSize: '15px',
    fontWeight: 500,
    cursor: 'pointer'
  },
  ctaSecondary: {
    backgroundColor: '#ffffff',
    color: '#374151',
    border: '1px solid #e5e7eb',
    padding: '14px 28px',
    borderRadius: '8px',
    fontSize: '15px',
    fontWeight: 500,
    cursor: 'pointer'
  },
  footer: {
    position: 'relative',
    zIndex: 1,
    borderTop: '1px solid #f3f4f6',
    padding: '64px 24px 32px',
    backgroundColor: 'rgba(255,255,255,0.9)'
  },
  footerInner: {
    maxWidth: '1120px',
    margin: '0 auto',
    display: 'grid',
    gridTemplateColumns: '1fr 2fr',
    gap: '64px',
    marginBottom: '48px'
  },
  footerBrand: {},
  footerTagline: {
    fontSize: '14px',
    color: '#9ca3af',
    marginTop: '12px'
  },
  footerLinks: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '32px'
  },
  footerCol: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
  },
  footerHeading: {
    fontSize: '13px',
    fontWeight: 600,
    color: '#111827',
    marginBottom: '4px'
  },
  footerLink: {
    fontSize: '14px',
    color: '#6b7280',
    textDecoration: 'none'
  },
  footerBottom: {
    maxWidth: '1120px',
    margin: '0 auto',
    paddingTop: '32px',
    borderTop: '1px solid #f3f4f6',
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: '13px',
    color: '#9ca3af'
  },
  legalLinks: {
    display: 'flex',
    gap: '24px'
  },
  legalLink: {
    color: '#9ca3af',
    textDecoration: 'none'
  }
};

export default ZygoSecPrivacy;
